import sector from './sector.reducers';
import user from './user.reducers';
import entity from './entity.reducers';
import sidebar from './sidebar.reducers';
import navigation from './navigation.reducers';
import layer from './layer.reducers';
import faction from './faction.reducers';
import settings from './settings.reducers';
import tag from './tag.reducers';

export default {
  sector,
  user,
  entity,
  sidebar,
  navigation,
  layer,
  faction,
  settings,
  tag,
};
